<template>
    <div class="about-panel">
        <h1>Requirements</h1>

        <h2>System</h2>
        <p>The game is designed to be played on desktop only.<br /></p>

        <div>
            <ul class="blood-list">
                <li><strong>Screen:</strong> 1920x1080 or higher is recommended</li>
                <li><strong>Internet:</strong> Stable connection</li>
            </ul>
        </div>

        <h2>Browser</h2>
        <p>
            The game makes extensive use of the latest web technologies, so a modern browser is
            required.<br />
        </p>

        <div>
            <ul class="blood-list">
                <li><strong>Modern CSS & JavaScript ( ES2023 )</strong></li>
                <li><strong>WebGL 2.0:</strong> Game rendering and graphics</li>
                <li><strong>IndexedDB:</strong> Local database storage</li>
                <li><strong>Web Assembly:</strong> Hash algorithm</li>
            </ul>

            <p>Any up-to-date browser should work : Chrome, Firefox, Safari, Opera, Edge...</p>
        </div>

        <h2>Performance Notes</h2>
        <div>
            <ul class="blood-list">
                <li>Hardware acceleration should be enabled in your browser settings</li>
                <li>Close unnecessary browser tabs for optimal performance during gameplay</li>
            </ul>
        </div>
    </div>
</template>
<script setup lang="ts"></script>
